import { Box, Typography } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'

import React from 'react'

import Html from '../../Html/Html'

const TwoColumnContainer = styled(Box)(({ theme, layout_columns }) => ({
  display: 'grid',
  gridTemplateColumns: layout_columns === 1 ? '1fr' : '1fr 1fr',
  gap: layout_columns === 1 ? theme.spacing(4) : theme.spacing(0),
  padding: layout_columns === 1 ? theme.spacing(4, 2) : theme.spacing(0),
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: '1fr',
    padding: theme.spacing(4, 2),
    gap: theme.spacing(4),
  },
}))

const ColumnContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isLeft',
})(({ theme, isLeft, html_before }) => ({
  paddingRight: isLeft ? theme.spacing(7.5) : 0,
  paddingLeft: !isLeft && html_before ? theme.spacing(7.5) : 0,
  [theme.breakpoints.down('md')]: {
    padding: isLeft
      ? theme.spacing(0, 7.5, 5, 7.5)
      : theme.spacing(0, 7.5, 0, 0),
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
  },
}))

const IconImage = styled('img')(({ theme }) => ({
  width: 70,
  height: 70,
  marginRight: theme.spacing(2),
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 54,
  lineHeight: '64px',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    fontSize: 32,
    lineHeight: '40px',
  },
}))

const BulletContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(6.25),
}))

const BulletTitle = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 500,
  marginBottom: theme.spacing(1.25),
}))

export default function TwoColumnBulleted({ data }) {
  const { html_before, layout_columns } = data
  const theme = useTheme()

  return (
    <TwoColumnContainer layout_columns={layout_columns}>
      {html_before && (
        <ColumnContainer isLeft html_before={html_before}>
          <Title variant="h1">{data.title}</Title>
          <Html content={html_before} />
        </ColumnContainer>
      )}
      <ColumnContainer html_before={html_before}>
        {data.columns?.map((column, colIndex) =>
          column.bullets.map((bullet, bulletIndex) => (
            <BulletContainer key={`${colIndex}-${bulletIndex}`}>
              <IconImage
                src={bullet.icon_image?.localAsset?.publicURL}
                alt={bullet.icon_image?.title || ''}
              />
              <Box>
                <BulletTitle>{bullet.title}</BulletTitle>
                <Html content={bullet.html} />
              </Box>
            </BulletContainer>
          ))
        )}
      </ColumnContainer>
    </TwoColumnContainer>
  )
}